import { FeatureFlag } from '../FeatureFlag';

export const useAlphaEyeLightweightChartQuery = new FeatureFlag({
    key: 'use-alpha-eye-lightweight-chart',
    defaultValue: false,
});
